// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3871":"1c3baec8","4968":"ec9201e1"}[chunkId] + ".chunk.css";
};